import { useEffect, useState } from 'react';
import InputLabel from '../InputLabel/InputLabel';
import inputStyles from '../InputLabel/Input.module.css';
import { Checkbox } from '../index';

const Input = ({
    btnChildren,
    children,
    required,
    info,
    style,
    max,
    extended,
    fullWidth = true,
    forceMargin = false,
    margin = true,
    isMulti,
    label,
    note,
    labelStyles,
    afterInput,
    readOnlySecondary,
    ...props
}: any) => {
    const [isActive, setIsActive] = useState(!!props.value?.toString().trim());
    const [isTitleActive, setIsTitleActive] = useState(false);

    const [value, setValue] = useState(props.type === 'button' ? props.value || props.placeholder : props.value);

    useEffect(() => {
        // console.log('value', value, props.value);
        if (value !== props.value) {
            // if(props.type === 'button' ? value || props.placeholder : value)
            setValue(props.type === 'button' ? props.value || props.placeholder : props.value);
        }
    }, [props.value]);

    const onInput = (e: any) => {
        // console.log('e.target.value', e.target.value);
        const value = e.target.value;
        const trimmerValue = value?.trim() || '';
        setIsActive(!!trimmerValue);

        // console.log(max, value.length);

        if (max && value.length > max) {
            setValue(value.slice(0, max));
            e.target.value = value.slice(0, max);
        } else {
            setValue(value);
        }
    };

    const onMouseEnter = (e: any) => {
        const isOverflowing = e.target.scrollWidth > e.target.clientWidth;

        if (isOverflowing && (e.target.readOnly || e.target.disabled)) {
            setIsTitleActive(true);
            e.target.parentNode.setAttribute('data-title', e.target.value);
            // e.target.parentNode.classList.add(styles.hasTitle);
        }
    };

    const countHardLines = () => {
        const lines = value?.split(/\r\n|\r|\n/) || '';
        return lines.length;
    };

    return (
        <InputLabel
            label={children || label}
            info={info}
            required={required}
            isActive={isActive}
            isTitleActive={isTitleActive}
            max={max}
            style={style}
            extended={extended}
            valueLength={value?.length || 0}
            fullWidth={fullWidth}
            disabled={props.disabled}
            labelStyles={labelStyles}
            afterInput={afterInput}
            forceMargin={forceMargin}
            margin={margin}
        >
            {props.type === 'checkbox' ? (
                <Checkbox {...props} />
            ) : // : props.type === 'button' ? (
            // <Button {...props}>{btnChildren}</Button>
            // )
            props.type === 'textarea' ? (
                <>
                    {props.disabled ? (
                        <div className={`${inputStyles.inputFieldViewContainer}`}>
                            <div
                                className={`${inputStyles.inputField} 
                                ${inputStyles.inputFieldTextView} 
                                ${value?.length ? inputStyles.selected : ''}
                                `}
                            >
                                {value}
                            </div>
                        </div>
                    ) : (
                        <textarea
                            className={`${inputStyles.inputField} 
                            ${value?.length ? inputStyles.selected : ''}
                            ${value?.length && (isMulti || style === 'textPreview') ? inputStyles.selectedMulti : ''}
                            ${style === 'textPreview' ? inputStyles.inputFieldTextPreview : ''}
                            ${style === 'textPreview' && countHardLines() > 1 ? inputStyles.inputFieldTextPreviewSmall : ''}
                            ${props.readOnly ? inputStyles.readOnly : ''}
                            `}
                            required={required}
                            onInput={onInput}
                            cols={1}
                            rows={1}
                            {...props}
                            value={value ? value : props.readOnly ? props.placeholder : ''}
                        ></textarea>
                    )}
                </>
            ) : (
                <>
                    <input
                        className={`${inputStyles.inputField} 
                    ${props.value?.length ? inputStyles.selected : ''}
                    ${props.value?.length && (isMulti || style === 'textPreview') ? inputStyles.selectedMulti : ''}
                    ${!!note ? inputStyles.inputWithNote : ''}
                    ${readOnlySecondary ? inputStyles.readOnlySecondary : ''}
                    `}
                        required={required}
                        {...props}
                        value={value}
                        onMouseEnter={onMouseEnter}
                        onInput={onInput}
                    />

                    {!!note && <span className={inputStyles.inputNote}>{note}</span>}
                </>
            )}
        </InputLabel>
    );
};

export default Input;
